import {
  trackEventBuyer,
  trackEventSeller,
  trackEventBuyerWithExtraParams,
  trackEventSellerWithExtraParams,
} from "GTMs/libs";

type Primitive = string | boolean | number | undefined;

declare global {
  interface Window {
    trackEventSeller: typeof trackEventSeller;
    trackEventBuyer: typeof trackEventBuyer;
    trackEventBuyerWithExtraParams: typeof trackEventBuyerWithExtraParams;
    trackEventSellerWithExtraParams: typeof trackEventSellerWithExtraParams;
    dataLayer: object[];
    gtmDefaultParams: { [key: string]: Primitive };
    gtmExtraData: { [key: string]: Primitive };
    adjustedTime: number;
  }
}
export const ENUMSELLERFLOWTYPES = {
  Sellers: "Sellers",
  addpost: "addpost",
  survey: "survey",
}
export {};
